import React from 'react';
import {   InfoBox,   ExerciseBox,   CodeBlock,   InlineCode,   SectionTitle,  Note,  TableContainer,  Highlight,  PatternContainer,  SectionHeading,  SubHeading,  TwoColGrid,  ThreeColGrid,  GridItem,  Divider, Image} from '../../../../components/course/CourseComponents';
import screen1 from '../screen1.jpg';

const IntroductionContent = () => {
  return (
    <>
      <InfoBox title="Introduction" color="blue">
        <p className="mb-0">
        Il est temps de coder ton premier jeu vidéo !<br/>
        On va commencer simple, avec un mini-jeu qui te permettra d'améliorer ta visée — très utile si tu joues à Fortnite, Valorant, Counter-Strike… ou n'importe quel autre FPS!
        </p>
      </InfoBox>    

      <SectionTitle>🧠 Objectif du jeu</SectionTitle>
      
     

     

      <div className="flex flex-col md:flex-row gap-6 items-start mb-6">
        <div className="flex-1">
        <p className="mb-4">
      Dans ce mini-jeu, un cercle apparaît à une position aléatoire sur l'écran. L'objectif est simple : cliquer dessus le plus rapidement possible. À chaque clic réussi, le score augmente et le cercle est repositionné aléatoirement.
      </p>
        <p className="mb-4">
      Tout au long des chapitres, nous allons progressivement enrichir ce jeu :
      </p>
          <ul className="list-disc list-inside mb-4">
            <li>Ajouter un cercle à un endroit aléatoire</li>
            <li>Detecter si le cercle est cliqué</li>
            <li>Ajouter un score</li>
            <li>Ajouter un timer (compte à rebours)</li>
            <li>Implémenter un écran de démarrage et un écran de fin</li>
          </ul>
        </div>
        <div className="flex justify-center items-center">
          <Image 
            src={screen1} 
            alt="Aperçu du jeu de visée" 
            width="350px"
            height="350px"
            borderRadius="xl"
            shadow={true}
            border={false}
            className="object-contain"
          />
        </div>
      </div>

      <Note type="tip" title="Technologie utilisée :">
        Nous utiliserons JavaScript et la bibliothèque p5.js, qui fournit toutes les fonctions nécessaires à la création de jeux vidéo : interface simple pour gérer le rendu graphique, gérer les événements utilisateur et l'interaction en temps réel.
      </Note>

      <p>
      🎯 Prêt à coder ? C'est parti !
      </p>
     
    </>
  );
};

export default IntroductionContent; 